import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { breakpoints } from '@sainsburys-tech/boltui-utils';
import * as Styled from './Slider.styles';
import Nav from './Nav/Nav';
import generateSlides from './helpers/generateSlides';
import { getNextIndex, getPreviousIndex } from './helpers/getIndexes';

var noop = function noop() {};

var mockedEvent = {
  preventDefault: noop,
  stopPropagation: noop,
  isInternalUpdate: true
};

var Slider = /*#__PURE__*/function (_Component) {
  _inherits(Slider, _Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (event, updateCallback) {
      if (event) event.preventDefault();
      var _this$props = _this.props,
          itemsPerSlideXs = _this$props.itemsPerSlideXs,
          itemsPerSlideSm = _this$props.itemsPerSlideSm,
          itemsPerSlideMd = _this$props.itemsPerSlideMd,
          itemsPerSlideLg = _this$props.itemsPerSlideLg,
          items = _this$props.items,
          indexOfFirstDisplayedItem = _this$props.indexOfFirstDisplayedItem,
          currentSlide = _this$props.currentSlide;
      var currentSlideProvided = currentSlide;
      var newItemsPerSlide = _this.screenLg.matches ? itemsPerSlideLg : _this.screenMd.matches ? itemsPerSlideMd : _this.screenSm.matches ? itemsPerSlideSm : itemsPerSlideXs;
      var _this$state = _this.state,
          itemsPerSlide = _this$state.itemsPerSlide,
          currentIndex = _this$state.currentIndex;
      var lastItemIndexOnScreen = Math.min(Math.max(currentIndex * itemsPerSlide, 1), items.length);
      var preferedInitialSlide = Math.ceil(Math.min(indexOfFirstDisplayedItem, items.length) / newItemsPerSlide);
      var slideOfLastSeen = newItemsPerSlide > 0 ? Math.ceil(lastItemIndexOnScreen / newItemsPerSlide) : 1;
      var newCurrentIndex = indexOfFirstDisplayedItem > 0 ? preferedInitialSlide : slideOfLastSeen;
      var newNumberOfSlides = newItemsPerSlide > 0 ? Math.ceil(items.length / newItemsPerSlide) : 0;
      var nextIndex = getNextIndex(newCurrentIndex, newNumberOfSlides);
      var previousIndex = getPreviousIndex(newCurrentIndex, newNumberOfSlides);

      _this.setState({
        slidingFromDirection: undefined,
        itemsPerSlide: newItemsPerSlide,
        numberOfSlides: newNumberOfSlides,
        currentIndex: currentSlideProvided ? currentSlide : newCurrentIndex,
        previouslyActiveIndex: 0,
        nextIndex: nextIndex,
        previousIndex: previousIndex
      }, updateCallback);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (event) {
      var disableSwipe = _this.props.disableSwipe;
      if (disableSwipe) return;
      var dragStartX = event.touches[0].pageX;

      _this.setState({
        dragStart: dragStartX
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function (event) {
      var _this$props2 = _this.props,
          minHorizontalPxDrag = _this$props2.minHorizontalPxDrag,
          isInfiniteCycle = _this$props2.isInfiniteCycle,
          disableSwipe = _this$props2.disableSwipe;
      var _this$state2 = _this.state,
          nextIndex = _this$state2.nextIndex,
          previousIndex = _this$state2.previousIndex,
          dragStart = _this$state2.dragStart,
          numberOfSlides = _this$state2.numberOfSlides;
      if (disableSwipe) return;
      var dragEnd = event.changedTouches[0].pageX;
      var offset = dragStart - dragEnd;
      var SCROLL_OFFSET_TO_STOP_SCROLL = 30;

      var _ref = offset > 0 ? [nextIndex, 'right', nextIndex === 1] : [previousIndex, 'left', previousIndex === numberOfSlides],
          _ref2 = _slicedToArray(_ref, 3),
          newIndex = _ref2[0],
          slidingFromDirection = _ref2[1],
          willCycle = _ref2[2];

      if (Math.abs(offset) > SCROLL_OFFSET_TO_STOP_SCROLL) {
        if (event) event.preventDefault();
      }

      if (willCycle && !isInfiniteCycle) return;

      if (Math.abs(offset) > minHorizontalPxDrag) {
        _this.goToSlide(newIndex, slidingFromDirection, event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goToSlide", function (newIndex, slidingFromDirection, event) {
      var _this$state3 = _this.state,
          numberOfSlides = _this$state3.numberOfSlides,
          currentIndex = _this$state3.currentIndex;
      var onSlideChanged = _this.props.onSlideChanged;
      if (event) event.preventDefault();
      if (newIndex === currentIndex) return;
      var nextIndex = getNextIndex(newIndex, numberOfSlides);
      var previousIndex = getPreviousIndex(newIndex, numberOfSlides);
      var newState = {
        currentIndex: newIndex,
        previouslyActiveIndex: currentIndex,
        nextIndex: nextIndex,
        previousIndex: previousIndex,
        slidingFromDirection: slidingFromDirection
      };

      _this.setState(newState, function () {
        return onSlideChanged(newState.currentIndex, slidingFromDirection, event);
      });
    });

    _this.state = {
      slidingFromDirection: undefined,
      previouslyActiveIndex: 0,
      dragStart: 0,
      itemsPerSlide: _this.props.itemsPerSlide ? _this.props.itemsPerSlide : 0,
      numberOfSlides: _this.props.numberOfSlides ? _this.props.numberOfSlides : 0,
      currentIndex: _this.props.currentSlide ? _this.props.currentSlide : 0,
      nextIndex: 0,
      previousIndex: 0
    };
    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          mockWindow = _this$props3.mockWindow,
          onSliderLoaded = _this$props3.onSliderLoaded;
      var sm = breakpoints.sm,
          md = breakpoints.md,
          lg = breakpoints.lg;
      this.screenSm = mockWindow ? mockWindow.matchMedia(sm) : window.matchMedia(sm);
      this.screenMd = mockWindow ? mockWindow.matchMedia(md) : window.matchMedia(md);
      this.screenLg = mockWindow ? mockWindow.matchMedia(lg) : window.matchMedia(lg);
      this.screenSm.addListener(this.handleResize);
      this.screenMd.addListener(this.handleResize);
      this.screenLg.addListener(this.handleResize);
      this.handleResize(mockedEvent, onSliderLoaded);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevItems = prevProps.items,
          prevSlide = prevProps.currentSlide;
      var currentIndex = prevState.currentIndex;
      var _this$props4 = this.props,
          newItems = _this$props4.items,
          onSliderUpdated = _this$props4.onSliderUpdated,
          newCurrentSlide = _this$props4.currentSlide;

      if (prevItems.length !== newItems.length) {
        this.handleResize(mockedEvent, onSliderUpdated);
      }

      if (prevSlide !== newCurrentSlide) {
        this.goToSlide(newCurrentSlide, newCurrentSlide > currentIndex ? 'right' : 'left', mockedEvent);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.screenSm.removeListener(this.handleResize);
      this.screenMd.removeListener(this.handleResize);
      this.screenLg.removeListener(this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.numberOfSlides === 0) return null;
      var _this$props5 = this.props,
          className = _this$props5.className,
          transitionSpeed = _this$props5.transitionSpeed,
          showChevrons = _this$props5.showChevrons,
          showNavButtons = _this$props5.showNavButtons,
          isInfiniteCycle = _this$props5.isInfiniteCycle,
          items = _this$props5.items,
          slideClass = _this$props5.slideClass,
          size = _this$props5.size,
          navStyle = _this$props5.navStyle,
          innerAlignment = _this$props5.innerAlignment,
          dataTest = _this$props5['data-test'];
      var _this$state4 = this.state,
          currentIndex = _this$state4.currentIndex,
          slidingFromDirection = _this$state4.slidingFromDirection,
          nextIndex = _this$state4.nextIndex,
          previousIndex = _this$state4.previousIndex,
          itemsPerSlide = _this$state4.itemsPerSlide,
          previouslyActiveIndex = _this$state4.previouslyActiveIndex;
      var slidesOptions = {
        items: items,
        itemsPerSlide: itemsPerSlide,
        slidingFromDirection: slidingFromDirection,
        transitionSpeed: transitionSpeed,
        currentIndex: currentIndex,
        slideClass: slideClass,
        previouslyActiveIndex: previouslyActiveIndex,
        'data-test': dataTest
      };
      var slides = generateSlides(slidesOptions);
      var style = {
        width: "".concat(this.state.numberOfSlides * 100, "%")
      };
      var navProps = {
        content: slides,
        goToSlide: this.goToSlide,
        currentIndex: currentIndex,
        nextIndex: nextIndex,
        previousIndex: previousIndex,
        showChevrons: showChevrons,
        showNavButtons: showNavButtons,
        isInfiniteCycle: isInfiniteCycle,
        size: size,
        navStyle: navStyle
      };
      return /*#__PURE__*/React.createElement(Styled.Slider, {
        className: className,
        ref: function ref(slider) {
          _this2.slider = slider;
        },
        "data-test": dataTest
      }, /*#__PURE__*/React.createElement(Styled.Inner, {
        onTouchStart: this.handleDragStart,
        onTouchEnd: this.handleDragEnd,
        style: style,
        innerAlignment: innerAlignment,
        "data-test": "".concat(dataTest, "-inner")
      }, slides), /*#__PURE__*/React.createElement(Nav, _extends({}, navProps, {
        "data-test": "".concat(dataTest, "-nav"),
        className: "".concat(className, "__nav")
      })));
    }
  }]);

  return Slider;
}(Component);

Slider.displayName = 'Slider';
Slider.propTypes = {
  /**
   * Specify if is a warranty Item
   */
  indexOfFirstDisplayedItem: PropTypes.number,

  /**
   * The minimum number of pixels to be dragged horizontally to change slides (for mobile/tablet)
   */
  minHorizontalPxDrag: PropTypes.number,

  /**
   * The speed at which a slide transitions. 'slow' = 1.2s, 'medium' = 0.9s and 'fast' = 0.6s.
   */
  transitionSpeed: PropTypes.oneOf(['slow', 'medium', 'fast']),

  /**
   * | Enable/disable navigation chevrons
   */
  showChevrons: PropTypes.bool,

  /**
   * | Enable/disable navigation buttons
   */
  showNavButtons: PropTypes.bool,

  /**
   * Enable/disable infinite cycling throughout slides
   */
  isInfiniteCycle: PropTypes.bool,

  /**
   * The content of the Slider
   */
  items: PropTypes.arrayOf(PropTypes.element),

  /**
   * The number of items to put in each Slide on very small screen
   */
  itemsPerSlideXs: PropTypes.number,

  /**
   * The number of items to put in each Slide on small screen
   */
  itemsPerSlideSm: PropTypes.number,

  /**
   * The number of items to put in each Slide on tablet size screen
   */
  itemsPerSlideMd: PropTypes.number,

  /**
   * The number of items to put in each Slide on Desktop size screen
   */
  itemsPerSlideLg: PropTypes.number,

  /**
   * Layout classes for each Slide
   */
  slideClass: PropTypes.string,

  /**
   * Layout classes
   */
  className: PropTypes.string,

  /**
   * Optional callback invoked after mounting of the Slider
   */
  onSliderLoaded: PropTypes.func,

  /**
   * Optional callback invoked after re-rendering of the Slider
   */
  onSliderUpdated: PropTypes.func,

  /**
   * Optional callback invoked after navigating to other Slides
   */
  onSlideChanged: PropTypes.func,

  /**
   * Set the slide you currently want to be active when mounting
   */
  currentSlide: PropTypes.number,

  /**
   * Visual size of the buttons
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),

  /**
   * Data test attribute for end to end testing
   */
  navStyle: PropTypes.oneOf(['default', 'withSlideCount']),

  /**
   * Alignment of items in the Slider
   */
  innerAlignment: PropTypes.string,

  /**
   * Set the navigation buttons style
   */
  'data-test': PropTypes.string
};
Slider.defaultProps = {
  mockWindow: undefined,
  indexOfFirstDisplayedItem: 0,
  minHorizontalPxDrag: 80,
  transitionSpeed: 'fast',
  showChevrons: true,
  showNavButtons: true,
  isInfiniteCycle: false,
  items: [],
  itemsPerSlideXs: 0,
  itemsPerSlideSm: 0,
  itemsPerSlideMd: 0,
  itemsPerSlideLg: 0,
  slideClass: '',
  className: 'ac-slider',
  // this is to make the transition easier from ac-slider to Styled Components for now. Will eventually remove tihs default.
  onSliderLoaded: noop,
  onSliderUpdated: noop,
  onSlideChanged: noop,
  size: 'md',
  navStyle: 'default',
  innerAlignment: 'center',
  'data-test': 'component-slider'
};
export default Slider;
export { Slider };